import React, {useEffect} from 'react';
import {OrdinarStep} from './OrdinarStep';
import {ButtonBase} from '../elements';
import {useDispatch, useSelector} from 'react-redux';
import { getNotCalculatedStepsAsync, MOBILE_MODAL_COUPON } from '../../store/spirs/actions';
import {PeriodScoreElement, StepForm} from "../../models/api/codegen/code";
import {StoreType} from "../../store/spirs/types";
import {ExpressOrSystemStep} from "./ExpressOrSystemStep";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {getSteps} from "../../spirsApi/api-client";
import {View} from "./step-parts-components/StepFooter";
import {Visible} from "../../utils/Visible";
import {format} from "date-fns";
import {tab} from "../MyBets/MyBets";
import {useNavigate} from "react-router-dom";
import Timeout = NodeJS.Timeout;

const ShowAllStepsButton = styled(ButtonBase)`
    background-color: #EACD40;
    font-weight: 500;
    color: #121518;
    border: 1px solid #EACD40;
    border-radius: 8px;
    font-size: 14px;
    padding: 10px 20px;
    text-transform: uppercase;
` as typeof ButtonBase;

interface StepsType {
    calculated: boolean | undefined;
    actualDate: Date;
    currentTab: tab;
}

export const Steps = () => {
    const dispatch = useDispatch();
    const steps = useSelector((state: StoreType) => state.spirs.steps);
    const playerId = useSelector((state: StoreType) => state.spirs.playerInfo.playerId);

    useEffect(() => {
        dispatch(getNotCalculatedStepsAsync.request({playerId}));
        let id: Timeout | null;
        if (playerId) {
            id = setTimeout(() => {
                dispatch(getNotCalculatedStepsAsync.request({playerId}));
            }, 15000)
        }
        return () => {
            if (id) {
                clearTimeout(id);
            }
        }
    }, [playerId]);

    return (<BasicSteps steps={steps} view={"steps"} currentTab={"notCalculated"}/>);
};

export const MobileSteps: React.FC<StepsType> = ({actualDate, calculated, currentTab}) => {
    const [steps, setSteps] = React.useState<StepForm[]>([]);
    const playerId = useSelector((state: StoreType) => state.spirs.playerInfo.playerId);

    useEffect(() => {
        getSteps({playerId, startTime: actualDate.toISOString(), calculated}).then(data => data && setSteps(data));
    }, [calculated, actualDate, playerId]);
    const style = steps.length > 0 ? {backgroundColor: '#171a1e', paddingTop: '5px'} : {};
    return (<div style={style}>
        <BasicSteps steps={steps} view={"my-bets"} currentTab={currentTab}/>
    </div>);
};

interface BasicStepsType {
    steps: StepForm[];
    view: View;
    currentTab: tab;
}

export const BasicSteps = ({steps, view, currentTab}: BasicStepsType) => {
    const push = useNavigate();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const stepsLoaded = useSelector((state: StoreType) => state.spirs.stepsLoaded);

    function handleClick() {
        push('/sport/my-bets');
        dispatch(MOBILE_MODAL_COUPON(false))
    }

    return (
        <div className={view === "my-bets" ? "m-0" : "m-[8px]"}>
            {stepsLoaded && Boolean(steps.length === 0) && <div className="text-center text-white">
                {t('myBets.empty.' + currentTab)}
            </div>}
            <div className="overflow-y-auto max-h-[calc(100vh-300px)]" style={{scrollbarWidth: "none"}}>
                {steps.map((step: StepForm) =>
                    (step.type === 'EXPRESS' || step.type === 'SYSTEM')
                        ? <ExpressOrSystemStep key={step.id} step={step} view={view}/>
                        : <OrdinarStep key={step.id} step={step} view={view}/>
                )}
            </div>
            <Visible value={view === "steps"}>
                <div className="flex justify-center mt-[20px]">
                    <ShowAllStepsButton onClick={handleClick}>
                        {t('steps.showAllStepsButton')}
                    </ShowAllStepsButton>
                </div>
            </Visible>
        </div>
    );
}

export const Info: React.FC<{ step: StepForm, view: View }> = ({step, view}) => {
    const Score: React.FC<{ homeScore?: number, awayScore?: number, periodScores?: Array<PeriodScoreElement> }> = ({homeScore, awayScore, periodScores}) => {
        return (
            <>
                {!(homeScore == null || awayScore == null) &&
                <span style={{color: '#FD852F', fontFamily: "Roboto"}}>{homeScore} : {awayScore} </span>}

                {periodScores && periodScores.length != 0 &&
                <span>( {periodScores.map((key) => `${key.homeScore} : ${key.awayScore}`).join(', ')} )</span>}

            </>
        )
    };
    return (<div style={{color: '#ABABAB', fontSize: 16}}>
        <span style={{color: '#E7E7E7', fontWeight: 500, fontFamily: "Roboto"}}>
            {step.fixture && step.fixture.cn}
        </span>
        <div style={{color: '#E7E7E7', fontWeight: 500, fontFamily: "Roboto"}} >
            {view === 'my-bets' && `(${(step.fixture || {tn: ''}).tn})`}
        </div>
        <Visible value={view === "my-bets"}>
            <div>{step.fixture && step.fixture.st && format(new Date(step.fixture.st), 'HH:mm dd.MM.yyyy')}</div>
            {step.fixture && step.fixture.ms &&
            <Score homeScore={step.fixture.ms.homeScore}
                   awayScore={step.fixture.ms.awayScore}
                   periodScores={step.fixture.ms.periodScores}/>}
        </Visible>
    </div>)
};
